
import * as React from 'react';
import { useWeb3React } from '@web3-react/core';
import { Web3Provider } from '@ethersproject/providers';

import TarotJadeContainedButton from 'components/buttons/TarotJadeContainedButton';
import useInactiveListener from 'utils/hooks/web3/use-inactive-listener';
import { walletconnect } from 'utils/helpers/web3/connectors';
import useEagerConnect from 'utils/hooks/web3/use-eager-connect';
import { clearRouterCache } from 'contexts/TarotRouterProvider';

const WalletConnect = (): JSX.Element => {
  const {
    connector,
    activate,
    deactivate,
    active,
    error
  } = useWeb3React<Web3Provider>();

  // Handle logic to recognize the connector currently being activated
  const [activatingConnector, setActivatingConnector] = React.useState<any>();
  const [ignoreError, setIgnoreError] = React.useState(false);

  React.useEffect(() => {
    if (error?.name === 'UserRejectedRequestError') {
      setIgnoreError(true);
      return;
    }
    setIgnoreError(false);
  }, [error]);

  React.useEffect(() => {
    if (activatingConnector && activatingConnector === connector) {
      setActivatingConnector(undefined);
    }
  }, [
    activatingConnector,
    connector
  ]);

  // Handle logic to eagerly connect to the injected ethereum provider, if it exists and has granted access already
  const triedEager = useEagerConnect();

  // Handle logic to connect in reaction to certain events on the injected ethereum provider, if it exists
  useInactiveListener(!triedEager || !!activatingConnector);

  const currentConnector = walletconnect;
  const activating = currentConnector === activatingConnector;

  const handleActivate = () => {
    walletconnect.walletConnectProvider = undefined;
    setActivatingConnector(currentConnector);
    activate(walletconnect);
  };

  const handleDeactivate = () => {
    deactivate();
  };

  /*
  if (error && error instanceof UnsupportedChainIdError) {
    const { ethereum } = window as any;
    ethereum.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: CHAIN_DETAILS[CHAIN_IDS.FANTOM].chainId }]
    }).catch((switchError: any) => {
      // This error code indicates that the chain has not been added to MetaMask.
      if (switchError.code === 4902) {
        ethereum.request({
          method: 'wallet_addEthereumChain',
          params: [CHAIN_DETAILS[CHAIN_IDS.FANTOM]]
        }).catch((addError: any) => {
          // handle "add" error
          console.log(addError);
        });
      }
      // handle other "switch" errors
    });
  }
  */
  clearRouterCache();

  return (
    <>
      {(active || (error && !ignoreError)) ? (
        (error && !ignoreError) ? <></> :
          <TarotJadeContainedButton
            style={{
              height: 36
            }}
            onClick={handleDeactivate}>
          Disconnect Wallet
          </TarotJadeContainedButton>
      ) : (
        <TarotJadeContainedButton
          className='focus:outline-none focus:border-0 focus:ring-0'
          style={{
            height: 36
          }}
          disabled={activating}
          onClick={handleActivate}>
          <div className='my-4 flex justify-center items-center space-x-2'>
            <svg
              viewBox='0 0 40 40'
              width='24px'
              color='text'
              xmlns='http://www.w3.org/2000/svg'
              style={{
                alignSelf: 'center',
                fill: 'rgb(40, 13, 95)',
                flexShrink: 0
              }}>
              <path
                d='M8.68096 12.4756C14.9323 6.39698 25.0677 6.39698 31.3191 12.4756L32.0714 13.2071C32.384 13.511 32.384 14.0038 32.0714 14.3077L29.4978 16.8103C29.3415 16.9622 29.0881 16.9622 28.9318 16.8103L27.8965 15.8036C23.5354 11.563 16.4647 11.563 12.1036 15.8036L10.9948 16.8817C10.8385 17.0336 10.5851 17.0336 10.4288 16.8817L7.85517 14.3791C7.54261 14.0752 7.54261 13.5824 7.85517 13.2785L8.68096 12.4756ZM36.6417 17.6511L38.9322 19.8783C39.2448 20.1823 39.2448 20.675 38.9322 20.979L28.6039 31.022C28.2913 31.3259 27.7846 31.3259 27.472 31.022C27.472 31.022 27.472 31.022 27.472 31.022L20.1416 23.8942C20.0634 23.8182 19.9367 23.8182 19.8586 23.8942C19.8586 23.8942 19.8586 23.8942 19.8586 23.8942L12.5283 31.022C12.2157 31.3259 11.709 31.3259 11.3964 31.022C11.3964 31.022 11.3964 31.022 11.3964 31.022L1.06775 20.9788C0.755186 20.6749 0.755186 20.1821 1.06775 19.8782L3.35833 17.6509C3.6709 17.347 4.17767 17.347 4.49024 17.6509L11.8208 24.7789C11.8989 24.8549 12.0256 24.8549 12.1038 24.7789C12.1038 24.7789 12.1038 24.7789 12.1038 24.7789L19.4339 17.6509C19.7465 17.347 20.2533 17.347 20.5658 17.6509C20.5658 17.6509 20.5658 17.6509 20.5658 17.6509L27.8964 24.7789C27.9745 24.8549 28.1012 24.8549 28.1794 24.7789L35.5098 17.6511C35.8223 17.3471 36.3291 17.3471 36.6417 17.6511Z'
                fill='#3389FB'>
              </path>
            </svg>
            <span>WalletConnect</span>
          </div>
        </TarotJadeContainedButton>
      )}
    </>
  );
};

export default WalletConnect;
